import React from "react";
import { Box } from "../../../core/v2/Box/Box";

export const EarlyAdopterConsole: React.FC = () => {
  return <Box></Box>;
};
